export const norwegianTech = {
  templateId: 'tech',
  language: 'no',
  name: 'Teknologi & Elektronikk (Norsk)',
  description: 'Teknologi og elektronikk handleliste',
  icon: '📱',
  categories: [
    {
      name: 'Mobil og tilbehør',
      items: [
        'Mobildeksel',
        'Skjermskerm',
        'Mobillader',
        'Trådløs lader',
        'Powerbank',
        'Bluetooth hodetelefoner',
        'Bilholder',
        'Pop socket',
        'Minnekort',
        'USB-kabel',
        'Lightning-kabel',
        'Airpods',
        'Mobilen',
        'Selfiestang',
        'Kamera linse sett'
      ]
    },
    {
      name: 'Datamaskin og spill',
      items: [
        'Laptop',
        'Mus',
        'Tastatur',
        'Skjerm',
        'Webcam',
        'USB-hub',
        'Ekstern harddisk',
        'Gaming headset',
        'Kontroller',
        'Grafikkort',
        'RAM',
        'SSD',
        'Hovedkort',
        'Prosessor',
        'Kjølevifte'
      ]
    },
    {
      name: 'Smart hjem',
      items: [
        'Smarte lyspærer',
        'Smart bryter',
        'Smart høyttaler',
        'Sikkerhetskamera',
        'Smart ringeklokke',
        'Smart termostat',
        'Smart kontakt',
        'Robotstøvsuger',
        'Smart lås',
        'Bevegelsessensor',
        'Smart TV',
        'Streaming-enhet',
        'WiFi-ruter',
        'Range extender',
        'Smart display'
      ]
    },
    {
      name: 'Lyd og video',
      items: [
        'Bluetooth høyttaler',
        'Lydplanke',
        'Subwoofer',
        'Mikrofon',
        'Platespiller',
        'Vinylplater',
        'HDMI-kabel',
        'Lydkabel',
        'Studio monitorer',
        'DJ-mikser',
        'Forsterker',
        'Streaming kamera',
        'Stativ',
        'Ringlys',
        'Grønn skjerm'
      ]
    },
    {
      name: 'Bærbare enheter',
      items: [
        'Smartklokke',
        'Fitness tracker',
        'VR-headset',
        'Smarte briller',
        'Pulsmåler',
        'Smart ring',
        'Aktivitetsmåler',
        'Søvntracker',
        'GPS-klokke',
        'Smarte ørepropper'
      ]
    }
  ]
};
